import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';

import starsIcon from 'assets/images/icon-stars.png';
import { Society } from 'types';

type AiAgentButtonProps = {
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  disabled?: boolean;
  society: Society | null;
};

const AiAgentButton: FC<AiAgentButtonProps> = ({
  variant = 'primary',
  disabled,
  society,
}) => {
  const history = useHistory();
  const theme = useSelector(
    (state: State) => state.society?.actualSociety?.customization?.theme
  );

  const handleNavigateToAiAgentPage = () => {
    if (disabled) return;
    const societyId = society?._id || '';
    history.push(`/sociedad-ai/${societyId}`, {
      entrySource: 'header_button',
    });
  };

  return (
    <button
      type="button"
      title="IA Agent"
      className={`btn btn-outline-${variant} bg-transparent px-1`}
      style={{
        color: theme?.headerTextColor,
        borderColor: theme?.headerTextColor,
      }}
      onClick={handleNavigateToAiAgentPage}
      disabled={disabled}
    >
      <img src={starsIcon} alt="IA" width={20} height={20} />
    </button>
  );
};

export default AiAgentButton;
